import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-dental-drug-allergy",
  templateUrl: "./dental-drug-allergy.component.html",
  styleUrls: ["./dental-drug-allergy.component.scss"],
})
export class DentalDrugAllergyComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
